const Types = {
  SET_CREDENTIALS: '@AUTH/SET_CREDENTIALS',  
}

const INITIAL_STATE = {
  credentials: null,
}

export default function reducers (state = INITIAL_STATE, { type, payload }) {
  switch(type) {
    case Types.SET_CREDENTIALS:
      return { ...state, credentials: payload };
    default:
      return state;
  }
}
export const setSecurityCredential = (credentials) => ({
  type: Types.SET_CREDENTIALS,
  payload: {
    field: 'security_email',
    ...credentials
  }
});

export const setCredential = (email) => ({
  type: Types.SET_CREDENTIALS,
  payload: {
    field: 'email',
    value: email,
    publicValue: email,
    document: undefined
  }
});
